(function () {
  var SECTION_SELECTOR = '.product.product--v2';
  var THUMBNAIL_GAP_DESKTOP = 6;
  var THUMBNAIL_GAP_MOBILE = 4;
  var MOBILE_QUERY = '(max-width: 768px)';
  var PREORDER_REGION_SELECTOR = '[data-js-preorder-region]';
  var SHOP_PAY_BUTTON_SELECTORS = [
    'shop-pay-button',
    '[data-testid="ShopifyPay-button"]',
    '.shopify-payment-button__button--branded'
  ];

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function getThumbnailGap() {
    return window.matchMedia(MOBILE_QUERY).matches ? THUMBNAIL_GAP_MOBILE : THUMBNAIL_GAP_DESKTOP;
  }

  function applyThumbnailLayout(thumbnails) {
    var gap = getThumbnailGap();

    function apply(params) {
      if (!params) {
        return;
      }

      params.slidesPerView = 'auto';
      params.spaceBetween = gap;
    }

    apply(thumbnails.params);
    apply(thumbnails.originalParams);

    var breakpoints = thumbnails.originalParams && thumbnails.originalParams.breakpoints;

    if (breakpoints) {
      Object.keys(breakpoints).forEach(function (key) {
        apply(breakpoints[key]);
      });
    }

    thumbnails.update();
  }

  function setupCounter(section, slider) {
    var counter = section.querySelector('[data-js-media-counter]');

    if (!counter) {
      return;
    }

    var current = counter.querySelector('[data-js-media-counter-current]');
    var total = counter.querySelector('[data-js-media-counter-total]');

    if (!current) {
      return;
    }

    function update() {
      var index = typeof slider.realIndex === 'number' ? slider.realIndex : 0;

      current.textContent = pad(index + 1);

      if (total) {
        total.textContent = pad(slider.slides ? slider.slides.length : 0);
      }
    }

    slider.on('slideChange', update);
    update();
  }

  function setupGallery(section) {
    var sliderEl = section.querySelector('[data-js-product-media-slider]');
    var thumbnailsEl = section.querySelector('.product-media__slider-thumbnails');

    if (!sliderEl) {
      return;
    }

    var attempts = 0;

    function check() {
      attempts += 1;

      var slider = sliderEl.swiper;
      var thumbnails = thumbnailsEl ? thumbnailsEl.swiper : null;

      if (slider && (!thumbnailsEl || thumbnails)) {
        if (thumbnails) {
          applyThumbnailLayout(thumbnails);

          window.addEventListener('resize', function () {
            applyThumbnailLayout(thumbnails);
          });
        }

        setupCounter(section, slider);
        return;
      }

      if (attempts > 300) {
        return;
      }

      window.requestAnimationFrame(check);
    }

    check();
  }

  function openNewsletterPopup() {
    var popup = document.querySelector('.newsletter-popup');

    if (!popup) {
      return;
    }

    popup.classList.add('is-visible');

    var input = popup.querySelector('input[type="email"]');

    if (input) {
      input.focus();
    }
  }

  function setupNewsletterDiscount(section) {
    var container = section.querySelector('[data-js-newsletter-discount]');

    if (!container) {
      return;
    }

    var button = container.querySelector('[data-js-newsletter-discount-open]');

    if (button) {
      button.addEventListener('click', openNewsletterPopup);
    }

    var priceEl = container.querySelector('[data-js-newsletter-discount-price]');
    var pricesEl = container.querySelector('[data-js-newsletter-discount-prices]');

    if (!priceEl || !pricesEl) {
      return;
    }

    var prices = null;

    try {
      prices = JSON.parse(pricesEl.textContent);
    } catch (error) {
      return;
    }

    var eventBus = window.themeCore && window.themeCore.EventBus;

    if (!eventBus || !eventBus.listen) {
      return;
    }

    eventBus.listen('pdp:section-' + section.dataset.sectionId + ':change-variant', function (data) {
      var variantId = data && data.variant && data.variant.id;

      if (!variantId || !prices[variantId]) {
        return;
      }

      priceEl.textContent = prices[variantId];
    });
  }

  function findShopPayButton(container) {
    for (var i = 0; i < SHOP_PAY_BUTTON_SELECTORS.length; i += 1) {
      var found = container.querySelector(SHOP_PAY_BUTTON_SELECTORS[i]);

      if (found && found.getBoundingClientRect().height > 0) {
        return found;
      }
    }

    return null;
  }

  function setupShopPayLabel(section) {
    var container = section.querySelector('[data-js-shop-pay-label]');

    if (!container || container.dataset.shopPayLabelInitialized === 'true') {
      return null;
    }

    var defaultLabel = container.getAttribute('data-shop-pay-label') || '';
    var preorderLabel = container.getAttribute('data-shop-pay-label-preorder') || '';

    if (!defaultLabel && !preorderLabel) {
      return null;
    }

    container.dataset.shopPayLabelInitialized = 'true';

    var overlay = document.createElement('span');

    overlay.className = 'product-shop-pay-label';
    overlay.setAttribute('aria-hidden', 'true');
    container.appendChild(overlay);

    var button = null;

    function isPreorder() {
      var cartButton = section.querySelector('.add-to-cart');

      return !!(cartButton && cartButton.hasAttribute('data-preorder'));
    }

    function place() {
      if (!button || !button.isConnected) {
        overlay.classList.remove('is-visible');
        return;
      }

      var target = button.getBoundingClientRect();
      var host = container.getBoundingClientRect();

      if (!target.height) {
        overlay.classList.remove('is-visible');
        return;
      }

      overlay.style.top = target.top - host.top + 'px';
      overlay.style.left = target.left - host.left + 'px';
      overlay.style.width = target.width + 'px';
      overlay.style.height = target.height + 'px';
      overlay.classList.add('is-visible');
    }

    function update() {
      var label = isPreorder() ? preorderLabel : defaultLabel;

      if (!label) {
        overlay.classList.remove('is-visible');
        return;
      }

      overlay.textContent = label;
      place();
    }

    var attempts = 0;

    function waitForButton() {
      attempts += 1;
      button = findShopPayButton(container);

      if (button) {
        update();

        if (window.ResizeObserver) {
          new window.ResizeObserver(place).observe(button);
        }

        window.addEventListener('resize', place);
        return;
      }

      if (attempts > 600) {
        return;
      }

      window.requestAnimationFrame(waitForButton);
    }

    waitForButton();

    return update;
  }

  function enforceButtonLabels(section) {
    var buttons = section.querySelectorAll('[data-atc-label]');

    if (!buttons.length) {
      return null;
    }

    function intended(button) {
      return button.hasAttribute('data-preorder')
        ? button.getAttribute('data-preorder-label')
        : button.getAttribute('data-atc-label');
    }

    function apply() {
      Array.prototype.forEach.call(buttons, function (button) {
        var want = intended(button);

        if (want && button.textContent.trim() !== want) {
          button.textContent = want;
        }
      });
    }

    apply();

    if (window.MutationObserver) {
      Array.prototype.forEach.call(buttons, function (button) {
        var observer = new window.MutationObserver(function () {
          var want = intended(button);

          if (want && button.textContent.trim() !== want) {
            observer.disconnect();
            button.textContent = want;
            observer.observe(button, { childList: true, characterData: true, subtree: true });
          }
        });

        observer.observe(button, { childList: true, characterData: true, subtree: true });
      });
    }

    return apply;
  }

  function setupPreorder(section, onRefresh) {
    var sectionId = section.dataset.sectionId;
    var productUrl = section.dataset.url;
    var eventBus = window.themeCore && window.themeCore.EventBus;

    if (!sectionId || !productUrl || !eventBus || !eventBus.listen) {
      return;
    }

    var pending = null;

    function refresh(variantId) {
      var url = productUrl + '?section_id=' + encodeURIComponent(sectionId);

      if (variantId) {
        url += '&variant=' + encodeURIComponent(variantId);
      }

      if (pending) {
        pending.abort();
      }

      pending = new AbortController();

      fetch(url, { signal: pending.signal })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelectorAll(PREORDER_REGION_SELECTOR);
          var current = section.querySelectorAll(PREORDER_REGION_SELECTOR);

          if (!fresh.length || fresh.length !== current.length) {
            return;
          }

          Array.prototype.forEach.call(current, function (node, index) {
            var next = fresh[index];

            if (node.tagName === 'INPUT') {
              node.name = next.getAttribute('name') || '';
              node.value = next.getAttribute('value') || '';
              return;
            }

            if (next.hasAttribute('data-preorder')) {
              node.setAttribute('data-preorder', '');
            } else {
              node.removeAttribute('data-preorder');
            }

            if (node.innerHTML !== next.innerHTML) {
              node.innerHTML = next.innerHTML;
            }
          });

          if (typeof onRefresh === 'function') {
            onRefresh();
          }
        })
        .catch(function () {});
    }

    eventBus.listen('pdp:section-' + sectionId + ':change-variant', function (data) {
      if (!data || data.firstInitialization) {
        return;
      }

      refresh(data.variantId || (data.variant && data.variant.id));
    });
  }

  function init(section) {
    if (!section || section.dataset.pdpV2Initialized === 'true') {
      return;
    }

    section.dataset.pdpV2Initialized = 'true';

    setupGallery(section);
    setupNewsletterDiscount(section);
    var updateShopPayLabel = setupShopPayLabel(section);
    var applyButtonLabels = enforceButtonLabels(section);

    setupPreorder(section, function () {
      if (applyButtonLabels) {
        applyButtonLabels();
      }

      if (updateShopPayLabel) {
        updateShopPayLabel();
      }
    });
  }

  function initAll(context) {
    var root = context || document;
    var sections = root.querySelectorAll ? root.querySelectorAll(SECTION_SELECTOR) : [];

    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
